import React from "react";
import { Box, Slider, SliderProps, Typography } from "@mui/material";

type TPerCentSliderProps = {
  value: number;
  handleChange: (value: number) => void;
};

const PerCentSlider = (props: TPerCentSliderProps & SliderProps) => {
  const { value, handleChange, ...rest } = props;
  return (
    <Slider
      value={value}
      min={0}
      max={100}
      step={10}
      marks
      valueLabelFormat={(value) => `${value}%`}
      sx={{ width: "70%" }}
      onChange={(_, value) => handleChange(value as number)}
      {...rest}
    />
  );
};

const LabeledPerCentSlider = (
  props: { label: string } & TPerCentSliderProps & SliderProps
) => {
  const { label, value, handleChange, ...rest } = props;
  return (
    <Box
      gap={2}
      display="flex"
      flexDirection="row"
      sx={{ alignItems: "center" }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: "bold", width: "20%" }}>
        {label}
      </Typography>
      <PerCentSlider
        value={value}
        handleChange={handleChange}
        sx={{ width: "70%" }}
        {...rest}
      />
    </Box>
  );
};

export default LabeledPerCentSlider;
